import React from 'react';
import moment from 'moment';
import i18next from 'i18next';
import { Button } from '@uncinc/uncinc-react-kitchen-sink';

import { formatMoneyFromString } from '../../../../helpers';

import './style.scss';

const CourseInfoTeaser = ({ entity, className }) => {
  const date = moment(entity.getIn(['field_date_range', 0, 'value'], '-'));
  const endDate = moment(entity.getIn(['field_date_range', 0, 'end_value'], '-'));
  const location = entity.getIn(['field_location', 0, 'value'], '-');
  const cost = entity.getIn(['field_cost', 0, 'value']);
  const maxSpots = entity.getIn(['field_seats_available', 0, 'value'], false);
  const spotsTaken = entity.getIn(['field_seats_taken', 0, 'value'], 0);
  const availableSpots = maxSpots ? Math.max(maxSpots - spotsTaken, 0) : '0';
  const link = entity.getIn(['field_sign_up_link', 0, 'uri'], '-');
  const availableSpotsFlag = availableSpots > 0;

  const renderDate = () => {
    if (date.isSame(endDate, 'date')) {
      return `${date.format('H:mm uur')} - ${endDate.format('H:mm uur')}`;
    } else {
      return (
        <>
          <div>{date.format('DD-MM-YYYY H:mm')}</div>
          <div>{endDate.format('DD-MM-YYYY H:mm')}</div>
        </>
      );
    }
  };

  return (
    <div className="col-12 col-md-6 CourseDateTeaser">
      <div className="CourseDateTeaser__info">
        <div className="CourseDateTeaser__info__location">{location}</div>
        <div className="CourseDateTeaser__info__item">
          <div className="CourseDateTeaser__info__title">{i18next.t('date')}</div>
          <div className="CourseDateTeaser__info__body">{date.format('DD-MM-YYYY')}</div>
        </div>
        <div className="CourseDateTeaser__info__item">
          <div className="CourseDateTeaser__info__title">{i18next.t('date_time')}</div>
          <div className="CourseDateTeaser__info__body">{renderDate()}</div>
        </div>
        <div className="CourseDateTeaser__info__item">
          <div className="CourseDateTeaser__info__title">{i18next.t('costs')}</div>
          <div className="CourseDateTeaser__info__body">{cost ? formatMoneyFromString(cost) : '-'}</div>
        </div>
        <div className="CourseDateTeaser__info__availability">
          {i18next.t('training_spots', {
            availableSpots: availableSpots,
            maxSpots: maxSpots,
          })}
        </div>
        {availableSpotsFlag && (
          <Button
            className="Button--primary external-icon"
            href={link}>
            {i18next.t('teaser_signup_cta')}
          </Button>
        )}
      </div>
    </div>
  );
};

export default CourseInfoTeaser;
